/* tslint:disable */
/* eslint-disable */
/**
 * esign
 * eSign template authoring and request management service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const EsignPreviewDocumentSource = {
    SourcePdf: 'source_pdf',
    FinalPdf: 'final_pdf',
    None: 'none',
} as const;
export type EsignPreviewDocumentSource = typeof EsignPreviewDocumentSource[keyof typeof EsignPreviewDocumentSource];


export function instanceOfEsignPreviewDocumentSource(value: any): boolean {
    for (const key in EsignPreviewDocumentSource) {
        if (Object.prototype.hasOwnProperty.call(EsignPreviewDocumentSource, key)) {
            if (EsignPreviewDocumentSource[key as keyof typeof EsignPreviewDocumentSource] === value) {
                return true;
            }
        }
    }
    return false;
}

export function EsignPreviewDocumentSourceFromJSON(json: any): EsignPreviewDocumentSource {
    return EsignPreviewDocumentSourceFromJSONTyped(json, false);
}

export function EsignPreviewDocumentSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): EsignPreviewDocumentSource {
    return json as EsignPreviewDocumentSource;
}

export function EsignPreviewDocumentSourceToJSON(value?: EsignPreviewDocumentSource | null): any {
    return value as any;
}

export function EsignPreviewDocumentSourceToJSONTyped(value: any, ignoreDiscriminator: boolean): EsignPreviewDocumentSource {
    return value as EsignPreviewDocumentSource;
}

